var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"videoPreview_main"}},[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"id":"videoPreview_video"}})])}
var staticRenderFns = []

export { render, staticRenderFns }